export default __webpack_public_path__ + "static/media/red_prince.c8f0205e.png";